import type { ReactNode } from 'react';
import { RSRP_THRESHOLDS, type RatingLevel } from '@oscom/shared';

const LEGEND: { level: RatingLevel; range: string }[] = [
  { level: 5, range: `≥ ${RSRP_THRESHOLDS.level5}` },
  { level: 4, range: `${RSRP_THRESHOLDS.level4} bis unter ${RSRP_THRESHOLDS.level5}` },
  { level: 3, range: `${RSRP_THRESHOLDS.level3} bis unter ${RSRP_THRESHOLDS.level4}` },
  { level: 2, range: `${RSRP_THRESHOLDS.level2} bis unter ${RSRP_THRESHOLDS.level3}` },
  { level: 1, range: `unter ${RSRP_THRESHOLDS.level2}` },
];

/** The five RSRP levels of A with their colours and ranges. */
export function RatingLegend(): ReactNode {
  return (
    <ul className="rating-legend">
      {LEGEND.map((entry) => (
        <li key={entry.level}>
          <span className={`rating rating--${entry.level} rating-legend__swatch`}>
            {entry.level}
          </span>{' '}
          Stufe {entry.level}: {entry.range} dBm
        </li>
      ))}
    </ul>
  );
}
